
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2025-08-23-r3f-level-of-detail",
      function () {
        return require("private-next-pages/blogs/2025-08-23-r3f-level-of-detail/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2025-08-23-r3f-level-of-detail"])
      });
    }
  